export default __webpack_public_path__ + "static/media/app-store.60262b81.png";